var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnfilledIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_560_334",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_560_334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.37492 13.9583H10.6249V9.16666H9.37492V13.9583ZM9.9999 7.74039C10.1906 7.74039 10.3505 7.67589 10.4795 7.54689C10.6085 7.41789 10.673 7.25803 10.673 7.06732C10.673 6.87663 10.6085 6.71678 10.4795 6.58776C10.3505 6.45876 10.1906 6.39426 9.9999 6.39426C9.80919 6.39426 9.64934 6.45876 9.52034 6.58776C9.39134 6.71678 9.32684 6.87663 9.32684 7.06732C9.32684 7.25803 9.39134 7.41789 9.52034 7.54689C9.64934 7.67589 9.80919 7.74039 9.9999 7.74039ZM10.0013 17.9166C8.90635 17.9166 7.87716 17.7089 6.91371 17.2933C5.95025 16.8777 5.11218 16.3138 4.3995 15.6014C3.68681 14.8891 3.12259 14.0514 2.70686 13.0883C2.29112 12.1253 2.08325 11.0963 2.08325 10.0014C2.08325 8.90644 2.29103 7.87725 2.70659 6.9138C3.12214 5.95034 3.6861 5.11228 4.39846 4.3996C5.11084 3.6869 5.94854 3.12268 6.91156 2.70695C7.87458 2.29121 8.90356 2.08334 9.9985 2.08334C11.0934 2.08334 12.1226 2.29112 13.0861 2.70668C14.0495 3.12223 14.8876 3.68619 15.6003 4.39855C16.313 5.11093 16.8772 5.94863 17.2929 6.91166C17.7087 7.87467 17.9165 8.90365 17.9165 9.9986C17.9165 11.0935 17.7088 12.1227 17.2932 13.0862C16.8777 14.0496 16.3137 14.8877 15.6013 15.6004C14.889 16.3131 14.0513 16.8773 13.0882 17.293C12.1252 17.7088 11.0962 17.9166 10.0013 17.9166ZM9.9999 16.6667C11.861 16.6667 13.4374 16.0208 14.7291 14.7292C16.0207 13.4375 16.6666 11.8611 16.6666 9.99999C16.6666 8.13888 16.0207 6.56249 14.7291 5.27082C13.4374 3.97916 11.861 3.33332 9.9999 3.33332C8.13879 3.33332 6.5624 3.97916 5.27073 5.27082C3.97906 6.56249 3.33323 8.13888 3.33323 9.99999C3.33323 11.8611 3.97906 13.4375 5.27073 14.7292C6.5624 16.0208 8.13879 16.6667 9.9999 16.6667Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfilledIcon);
export default __webpack_public_path__ + "static/media/unfilledIcon.67acdb57f9324a44e13941e75dbb49f5.svg";
export { ForwardRef as ReactComponent };